import type { HistoryEntry, TierStat } from "../save/schema";

export interface TierTiming {
  tier: number;
  answered: number;
  right: number;
  /** Average seconds per question, or null if no timings were recorded. */
  seconds: number | null;
}

/** Average time and accuracy per tier across trials and practice, for tuning the trials. Pure. */
export function timingByTier(history: readonly HistoryEntry[]): TierTiming[] {
  const sum = new Map<number, TierStat>();
  for (const h of history)
    for (const [k, t] of Object.entries(h.tiers ?? {})) {
      const s = sum.get(Number(k)) ?? { n: 0, right: 0, ms: 0 };
      sum.set(Number(k), { n: s.n + t.n, right: s.right + t.right, ms: s.ms + t.ms });
    }
  return [...sum.entries()]
    .sort(([a], [b]) => a - b)
    .map(([tier, s]) => ({
      tier,
      answered: s.n,
      right: s.right,
      seconds: s.ms > 0 && s.n > 0 ? Math.round(s.ms / s.n / 100) / 10 : null,
    }));
}
